/**
 * 네비게이션 관련 스타일 컴포넌트
 */
import styled from 'styled-components';

export const Navigation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.theme.spacing.md};
  background-color: var(--bg-secondary);
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: background-color 0.3s ease, border-color 0.3s ease;
`;

export const NavButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.xs};
`;

export const Button = styled.button<{ $variant?: 'primary' | 'secondary' | 'danger' }>`
  width: 16px;
  height: 16px;
  aspect-ratio: 1/1;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const NavButton = styled.button`
  width: 24px;
  border-radius: ${props => props.theme.borderRadius.md};
  font-weight: ${props => props.theme.fontWeight.medium};
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  outline: none;

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }
  &:hover svg path {
    fill: ${props => props.theme.colors.book.color4b};
  }
`;

export const PageInfo = styled.div<{ $isExpanded?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${props => props.theme.colors.book.color9b};
  font-size: ${props => props.theme.fontSize.sm};
  font-weight: ${props => props.theme.fontWeight.normal};
  cursor: pointer;
  user-select: none;
  padding: 4px 8px;
  border-radius: ${props => props.theme.borderRadius.md};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${props => props.theme.colors.gray[100]};
  }
`;

export const PageInfoInput = styled.input`
  background: ${props => props.theme.colors.gray[100]};
  border: 1px solid ${props => props.theme.colors.gray[300]};
  border-radius: 4px;
  color: ${props => props.theme.colors.gray[700]};
  font-size: inherit;
  font-weight: 600;
  padding: 2px 6px;
  width: 50px;
  text-align: center;
  outline: none;
  transition: all 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary[500]};
    background: var(--bg-secondary);
  }

  &::placeholder {
    color: ${props => props.theme.colors.gray[400]};
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
